// extracted by mini-css-extract-plugin
var _1 = "MenuDefaultLogo-moduleMenuDefaultLogo__ceM0r";
var _2 = "MenuDefaultLogo-moduleicon__o_4yH";
export { _1 as "MenuDefaultLogo", _2 as "icon" }
